import getSubscriptionsSelect from 'modules/training/modules/subscription/selectors/get/index.js'
import { createSelector } from 'reselect'

const getDataSubscriptionsSelect = createSelector(
  getSubscriptionsSelect,
  /**
   * @type {ReduxModel[]}
   */
  (subscriptionInstances) => {
    return subscriptionInstances.map(
      subscriptionInstance => subscriptionInstance?.data
    )
  }
)

export default getDataSubscriptionsSelect
